module.exports = __webpack_public_path__ + "img/katarina_bedrooms_23.d7511a85.jpg";